import { Routes } from '@angular/router';

export const PRODUCER_PROFILE_PATHS = {
  BASE: 'producer-profile',
  PARTNER_ONBOARDING: 'partner-onboarding',
  PAYMENT_METHODS: 'payment-methods',
  EDIT_ESTABLISHMENT: 'edit-establishment',
  TEAM_MEMBER: 'team-member',
  DOCUMENT: 'document',
  ABOUT: 'about'
};

export const ProducerProfileRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@core/layout/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/producer-profile/producer-profile.page').then((m) => m.ProducerProfilePage)
      },
      {
        path: PRODUCER_PROFILE_PATHS.PARTNER_ONBOARDING,
        loadComponent: () =>
          import('./pages/partner-onboarding/partner-onboarding.page').then((m) => m.PartnerOnboardingPage)
      },
      {
        path: PRODUCER_PROFILE_PATHS.PAYMENT_METHODS,
        loadComponent: () => import('./pages/payment-methods/payment-methods.page').then((m) => m.PaymentMethodsPage),
        data: {
          title: 'Payment_Methods.Title'
        }
      },
      {
        path: PRODUCER_PROFILE_PATHS.EDIT_ESTABLISHMENT,
        loadComponent: () =>
          import('./pages/edit-establishment/edit-establishment.page').then((m) => m.EditEstablishmentPage),
        data: {
          title: 'Edit_Establishment.Title'
        }
      },
      {
        path: PRODUCER_PROFILE_PATHS.TEAM_MEMBER,
        loadComponent: () => import('./pages/team-member/team-member.page').then((m) => m.TeamMemberPage),
        data: {
          title: 'Team_Member.Team_Member'
        }
      },
      {
        path: PRODUCER_PROFILE_PATHS.DOCUMENT,
        loadComponent: () => import('./pages/document/document.page').then((m) => m.DocumentPage)
      },
      {
        path: PRODUCER_PROFILE_PATHS.ABOUT,
        loadComponent: () => import('./pages/about/about.page').then((m) => m.AboutPage),
        data: {
          title: 'About_Page.About'
        }
      }
    ]
  }
];
